import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'
import styled from 'styled-components'

import { Tilt as TiltBase } from '@application/Interfaces/Atoms/Tilt'

export const Parent = styled.div<{ overlayColor: string }>`
    position: relative;
    background-color: ${({ overlayColor }) => overlayColor};
    height: 100%;
`

type FakeBackgroundImageProp = {
    $height: string
    $mobileHeight: string
    $tabletHeight: string
    $showOnMobile: boolean
    $showOnTablet: boolean
}

export const BackgroundImageWrapper = styled.div<{ $height: string }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${({ $height }) => $height};
    z-index: 0;
`

export const FakeBackgroundImage = styled(GatsbyImage)<GatsbyImageProps & FakeBackgroundImageProp>`
    &.gatsby-image-wrapper {
        width: 100%;
        height: 100%;
    }

    & > img {
        object-fit: cover !important;
        object-position: 0% 0% !important;
        font-family: 'object-fit: cover !important; object-position: 0% 0% !important;';
    }

    @media ${(props) => props.theme.query.mobile} {
        & > picture {
            ${(props) => (props.$showOnMobile ? '' : 'display: none;')}
        }

        height: ${({ $mobileHeight }) => $mobileHeight};
    }

    @media ${(props) => props.theme.query.tablet} {
        & > picture {
            ${(props) => (props.$showOnTablet ? '' : 'display: none;')}
        }

        height: ${({ $tabletHeight }) => $tabletHeight};
    }
`

export const Content = styled.div``

export const Tilt = styled(TiltBase)`
    height: 100%;
`
